import React from 'react'
import Skeleton from 'react-loading-skeleton'
import PropTypes from 'prop-types'

class CustomSkeleton extends React.Component {

    render() {
        const { count, duration, delay, width, wrapper, height, circle, style, className, string, image, button } = this.props
        let styles = { backgroundColor: '#b6b4bd', ...style }
        styles = circle ? { borderRadius: '50%', ...styles } : styles
        styles = image ? { verticalAlign: 'middle', ...styles } : styles
        let classes = button ? `d-block bg-inherit ${className}` : className
        return (
            <Skeleton
                count={count}
                duration={duration}
                delay={delay}
                width={width}
                wrapper={wrapper}
                height={height}
                circle={circle}
                style={styles}
                className={classes}
                string={string} />
        )
    }
}

CustomSkeleton.propTypes = {
    count: PropTypes.number,
    duration: PropTypes.number,
    delay: PropTypes.number,
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    wrapper: PropTypes.string,
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    circle: PropTypes.bool,
    style: PropTypes.object,
    className: PropTypes.string,
    string: PropTypes.string,
    image: PropTypes.bool,
    button: PropTypes.bool,
}

export default CustomSkeleton



// WEBPACK FOOTER //
// ./src/components/UI/Skeleton.jsx